import React from "react";

const InnerPlayIcon = ({ style, size = 24 }) =>
  <svg width={size} height={size} style={style} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 4H15C14.4477 4 14 4.39797 14 4.88889V19.1111C14 19.602 14.4477 20 15 20H18C18.5523 20 19 19.602 19 19.1111V4.88889C19 4.39797 18.5523 4 18 4Z" fill="white" />
    <path d="M9 4H6C5.44772 4 5 4.39797 5 4.88889V19.1111C5 19.602 5.44772 20 6 20H9C9.55228 20 10 19.602 10 19.1111V4.88889C10 4.39797 9.55228 4 9 4Z" fill="white" />
  </svg>
  ;

export default InnerPlayIcon;

